import React from "react";

export default class Science extends React.Component {
  render() {
    return <div>Science</div>;
  }
}
